import CryptoJS from "crypto-js";
import { Signer, ethers, utils } from "ethers";

const symmetricDecryptData = (rawData: any, hashedPassword: string) => {
  const parts = rawData.split(":");
  const iv = CryptoJS.enc.Hex.parse(parts.shift());
  const encryptedText = parts.join(":");
  const key = CryptoJS.enc.Hex.parse(
    CryptoJS.SHA256(hashedPassword).toString(CryptoJS.enc.Hex)
  );

  const decrypted = CryptoJS.AES.decrypt(encryptedText, key, {
    iv: iv,
    mode: CryptoJS.mode.CTR,
    padding: CryptoJS.pad.NoPadding,
  });

  const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
  return decryptedString;
};

const symmetricEncryptData = (data: any, hashedPassword: any) => {
  const key = CryptoJS.enc.Hex.parse(
    CryptoJS.SHA256(hashedPassword).toString(CryptoJS.enc.Hex)
  );
  const iv = CryptoJS.lib.WordArray.random(128 / 8);

  const encrypted = CryptoJS.AES.encrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CTR,
    padding: CryptoJS.pad.NoPadding,
  });

  return iv.toString(CryptoJS.enc.Hex) + ":" + encrypted.toString();
};

export const decryptWallet = (
  encryptedWallet: string,
  password: string
): ethers.Wallet => {
  const hashedPassword = CryptoJS.SHA256(password).toString();
  const decryptedWallet = JSON.parse(
    symmetricDecryptData(encryptedWallet, hashedPassword)
  );
  return ethers.Wallet.fromMnemonic(decryptedWallet.mnemonic);
};

/**
 * @description This function is used to sign a message using the wallet private key
 *
 * @param message
 * @param signer
 * @returns Signed hash
 */
export const signMessage = async (message: string, signer: Signer) => {
  const signature = await signer.signMessage(utils.arrayify(message));

  return signature;
};
